import { TranslateService } from '@ngx-translate/core';
import { TranslationHelperService } from '../../../core/services/translate-helper.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';
import { OrderDetail } from '../../../core/store/edit-florder-detail/florder-detail.interface';
import { UntypedFormGroup } from '@angular/forms';
import { PanelStatus } from '../../florder/florder-edit-container/florder-edit.interface';
import { appSettings } from '../../../appSettings';

@Component({
  selector: 'app-ccr-edit-planning',
  templateUrl: './ccr-edit-planning.component.html',
  styleUrls: ['../../florder/florder-edit-planning/florder-edit-planning.component.scss'],
  animations: [
    trigger('growInOut', [
      state('in', style({ height: '50px' })),
      transition('void => *', [style({ height: 0 }), animate(400)]),
      transition('* => void', [animate(400, style({ height: 0 }))]),
    ]),
  ],
})
export class CCREditPlanningComponent implements OnChanges, OnInit {
  ordinalEnum: { id: string; value: string }[] = [];
  weekdayEnum: { id: string; value: string }[] = [];
  labelWidth = appSettings.LABEL_WIDTH;

  @Input() availablePickingDates: string[];
  @Input() orderDetail: OrderDetail;
  @Input() ccrForm: UntypedFormGroup;
  @Input() panelStatus: PanelStatus;

  constructor(private translationHelper: TranslationHelperService, private translate: TranslateService, private cd: ChangeDetectorRef) {}

  ngOnInit(): any {
    this.translationHelper
      .translateArray(
        ['FIRST', 'SECOND', 'THIRD', 'FOURTH', 'LAST'],
        (value, translation) => {
          return { id: value, value: translation };
        },
        'SHARED.ORDINAL.'
      )
      .subscribe(array => (this.ordinalEnum = array));
    const weekDays = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
    this.translationHelper
      .translateArray(
        weekDays,
        (value, translation) => {
          return { id: value, value: translation };
        },
        'SHARED.DAYS.'
      )
      .subscribe(array => (this.weekdayEnum = array));
    this.cd.markForCheck(); // Needed when changeDetectionStrategy == onPush
  }

  ngOnChanges() {
    this.cd.detectChanges();
  }
}
